(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('HospitalizationTypeDetailController', HospitalizationTypeDetailController);

    HospitalizationTypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'HospitalizationType', 'HospitalizationTypeParent'];

    function HospitalizationTypeDetailController($scope, $rootScope, $stateParams, entity, HospitalizationType, HospitalizationTypeParent) {
        var vm = this;
        vm.hospitalizationType = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:hospitalizationTypeUpdate', function(event, result) {
            vm.hospitalizationType = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
